import ApiError from "../../errors/ApiError";

export class LinkCustomerHostawayError extends ApiError {
  constructor() {
    super("Failed to link customer with Hostaway");
  }
}
